import { createSelector } from 'reselect';
import { IInterviewDetailState, IInterviewScheduleState, IUpdateInterviewState, ICancelInterviewState } from './types';

const selectScheduleMessageState = (state: { scheduleInterviewMessage: IInterviewScheduleState }) => state.scheduleInterviewMessage;
const selectScheduleDetailsState = (state: { interviewDetails: IInterviewDetailState }) => state.interviewDetails;
const selectUpdateInterviewState = (state: { updateInterview: IUpdateInterviewState }) => state.updateInterview;
const selectCancelInterviewState = (state: { cancelInterview: ICancelInterviewState }) => state.cancelInterview;

export const selectScheduledInterviewMessage = createSelector(
  selectScheduleMessageState,
  (scheduleState) => scheduleState.data?.message
);

export const selectScheduledInterviewMessageLoading = createSelector(
  selectScheduleMessageState,
  (scheduleState) => scheduleState.loading
);

export const selectScheduledInterviewMessageError = createSelector(
  selectScheduleMessageState,
  (scheduleState: IInterviewScheduleState) => scheduleState.error
);

export const selectInterviewDetail = createSelector(
  selectScheduleDetailsState,
  (detailState: IInterviewDetailState) => detailState.data
);

export const selectInterviewDetailLoading = createSelector(
  selectScheduleDetailsState,
  (detailState: IInterviewDetailState) => detailState.loading
);

export const selectInterviewDetailError = createSelector(
  selectScheduleDetailsState,
  (detailState: IInterviewDetailState) => detailState.error
);

export const selectUpdateInterviewMessage = createSelector(
  selectUpdateInterviewState,
  (updateState) => updateState.data?.message
);

export const selectUpdateInterviewLoading = createSelector(
  selectUpdateInterviewState,
  (updateState) => updateState.loading
);

export const selectUpdateInterviewError = createSelector(
  selectUpdateInterviewState,
  (updateState: IUpdateInterviewState) => updateState.error
);

export const selectCancelInterviewMessage = createSelector(
  selectCancelInterviewState,
  (cancelState) => cancelState.data?.message
);

export const selectCancelInterviewLoading = createSelector(
  selectCancelInterviewState,
  (cancelState) => cancelState.loading
);

export const selectCancelInterviewError = createSelector(
  selectCancelInterviewState,
  (cancelState: ICancelInterviewState) => cancelState.error
);
